.sizeChart
{
	&--clone
	{
		width: 100%;
		max-width: 500px;
	}

	.fitMeter
	{
		&__cell
		{
			position: relative;

			&:before {
				content: "";
				display: block;
				margin-bottom: map-get($spacers, 2);
				width: 100%;
				height: 10px;
				background: #e6e6e6;
				border-radius: $border-radius-pill;
			}

			&--on
			{
				&:before {
					background: #392693;
				}
			}
		}
	}

	&__tabs .btn
	{
		border-radius: $border-radius $border-radius 0 0;
		cursor: pointer;
		margin: 0 2px;
	}

	&--std
	{
		.met:not(.btn)
		{
			display: none;
		}
	}

	&--met
	{
		.std:not(.btn)
		{
			display: none;
		}
	}

	.table {
		--bs-table-bg: #E6E6E6;
		--bs-table-striped-bg: #F2F2F2;
	}

	.table > :not(:first-child)
	{
		border-color: $border-color;
		border-width: 1px;
	}
}